export function getCsvValues(csv: string) {
  const values: string[] = [];

  for (const value of csv.split(',')) {
    const trimmedValue = value.trim();
    if (trimmedValue.length > 0) {
      values.push(trimmedValue);
    }
  }

  return values;
}
